import { useEffect, useState } from "react";
import { api, getMich } from "../../api";

/**
 * Wie viele Rückfragen unbeantwortet sind.
 *
 * Die Meldungen liefen bisher nur in eine Richtung: jemand meldet, ein
 * Mensch liest. Wer an einer Meldung arbeitet, hat aber selbst Fragen — und
 * die hatten keinen Ort. Eine Frage, die niemand sieht, ist keine; deshalb
 * steht die Zahl in der Seitenleiste neben „Reports".
 *
 * Geteilt zwischen allen, die sie brauchen: die Leiste zeigt sie, die
 * Meldungsseite meldet nach jeder Antwort, dass sie sich geändert hat.
 * Zwei Abrufe für dieselbe Zahl wären zwei Zahlen, die auseinanderlaufen.
 */

let stand = 0;
const horcher = new Set<(n: number) => void>();

function setzen(n: number) {
  if (n === stand) return;
  stand = n;
  horcher.forEach((h) => h(n));
}

/** Holt die Zahl neu — nach dem Anmelden und nach jeder Antwort. */
export async function fragenNeuZaehlen(): Promise<void> {
  // Ohne Anmeldung gibt es die Liste nicht, und ein 403 im Protokoll bei
  // jedem Seitenaufruf wäre Lärm ohne Aussage.
  if (!getMich()) {
    setzen(0);
    return;
  }
  try {
    const r = await api<{ open: number }>("/reports/questions/open");
    setzen(r.open ?? 0);
  } catch {
    // Wer die Meldungen nicht sehen darf, hat auch keine offenen Fragen.
    setzen(0);
  }
}

export function useOffeneFragen(): number {
  const [n, setN] = useState(stand);
  useEffect(() => {
    horcher.add(setN);
    void fragenNeuZaehlen();
    return () => { horcher.delete(setN); };
  }, []);
  return n;
}
